import { FilterCheckbox, Flex } from "@capioweb/ui-components"
import { Text } from "@capioweb/ui-components/src"
import React from "react"
import { EpiFormOptionItem } from "../../../../@types/CapioWeb/epiForms"
import { LocalesContext } from "../../../../context"
import { updateInterest } from "../../api/updateInterests"

interface InterestsFieldsetProps {
	items: EpiFormOptionItem[]
}

const moveCheckedInterestToTop = (a, b) => {
	if (a.checked && b.checked) {
		return 0
	}
	if (a.checked) {
		return -1
	}
	if (b.checked) {
		return 1
	}
	return 0
}

const sortInterestsAlphabetically = (
	a: EpiFormOptionItem,
	b: EpiFormOptionItem
) => {
	if (a.caption < b.caption) {
		return -1
	}
	if (a.caption > b.caption) {
		return 1
	}
	return 0
}

export const InterestsFieldset: React.FC<InterestsFieldsetProps> = ({
	items,
}) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)

	const [showAll, setShowAll] = React.useState(false)

	// Keep local state of interests so we can set checked to true/false
	const [interests, setInterests] = React.useState(items)

	const handleInterestChange = async (interest: EpiFormOptionItem) => {
		const interestsBeforeUpdate = [...interests]

		// Update interests state before fetch so we don't experience lag
		const updatedInterests = interests.map((i) => {
			if (i.value === interest.value) {
				return {
					...i,
					checked: !i.checked,
				}
			} else {
				return i
			}
		})
		setInterests(updatedInterests)

		const result = await updateInterest(interest.value, !interest.checked)

		// If update failed we reset interests to previous state
		if (!result.success) {
			setInterests(interestsBeforeUpdate)
		}
	}

	return (
		<Flex alignItems={"center"} flexWrap={"wrap"}>
			{interests
				.sort(sortInterestsAlphabetically)
				.sort(moveCheckedInterestToTop)
				.slice(0, showAll ? interests.length : Math.min(6, interests.length))
				.map((interest, i) => {
					return (
						<Flex flexDirection={"row"} my={0.75} mr={1.5} key={i}>
							<FilterCheckbox
								onChange={() => handleInterestChange(interest)}
								label={interest.caption}
								checked={interest.checked}
							/>
						</Flex>
					)
				})}
			{interests.length > 6 && (
				<Flex
					as={"button"}
					onClick={() => {
						setShowAll((s) => !s)
					}}
				>
					<Text fontWeight={"bold"} mb={0} textDecoration={"underline"}>
						{showAll
							? translate(translationKeys.viewLess)
							: translate(translationKeys.viewMore)}
					</Text>
				</Flex>
			)}
		</Flex>
	)
}
